import { useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import memberApi from '@src/shared/services/member-api';
import {
  DialogBody,
  DialogClose,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@src/design-system/dialog';
import { Button } from '@src/design-system/button';
import { ReminderChannelFilter } from './reminder-channel-filter';
import { ReminderContentTypeFilter } from './reminder-content-type-filter';
import { ReminderCreatedByFilter } from './reminder-created-by-filter';
import { removeNullishFromObj } from '@src/shared/utils/helpers/remove-nullish-from-obj';
import type { TMember } from '@src/shared/types/member';

export type TTempFilters = {
  channel?: string | null;
  content_type?: string | null;
  created_by?: TMember | null;
};

export const ReminderFilterModal = () => {
  const [sp, setSp] = useSearchParams();

  const createdByParam = sp.get('created_by');
  const channelParam = sp.get('channel');
  const contentTypeParam = sp.get('content_type');

  const { data: membersData } = memberApi.useFetch(
    {
      user: createdByParam || undefined,
    },
    { enabled: !!createdByParam }
  );

  const member = membersData?.results?.[0];

  const [tempFilters, setTempFilters] = useState<TTempFilters>({
    channel: channelParam,
    content_type: contentTypeParam,
    created_by: member,
  });

  const onApplyClick = () => {
    const filters = removeNullishFromObj({
      ...tempFilters,
      created_by: tempFilters.created_by?.user.id,
    });

    setSp((prev) => {
      prev.delete('page_number');
      return {
        ...prev,
        ...(filters || {}),
      };
    });
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle>Filter</DialogTitle>
      </DialogHeader>

      <DialogBody>
        <div className='flex flex-col gap-4'>
          <ReminderChannelFilter
            tempFilters={tempFilters}
            setTempFilters={setTempFilters}
          />
          <ReminderContentTypeFilter
            tempFilters={tempFilters}
            setTempFilters={setTempFilters}
          />
          <ReminderCreatedByFilter
            tempFilters={tempFilters}
            setTempFilters={setTempFilters}
          />
        </div>
      </DialogBody>

      <DialogFooter>
        <DialogClose asChild>
          <Button
            className='flex-1'
            variant='primaryOutline'
          >
            Cancel
          </Button>
        </DialogClose>

        <DialogClose asChild>
          <Button
            className='flex-1'
            variant='primary'
            onClick={onApplyClick}
          >
            Apply
          </Button>
        </DialogClose>
      </DialogFooter>
    </>
  );
};
